import i18next from "i18next";
import * as Yup from "yup";
import { ProductType } from "../types/products.types";

export const productValidationSchema = (t: typeof i18next.t) => {
  return Yup.object({
    name: Yup.string().required(t("admin.products.side.form.productNameErrorMsg")),
  });
};

export const serviceValidationSchema = (t: typeof i18next.t) => {
  return Yup.object({
    name: Yup.string().required(t("productComponent.service.form.nameError")),
  });
};

export const getValidationSchema = (
  type: ProductType | undefined,
  t: typeof i18next.t
) => {
  if (type === ProductType.Service) {
    return serviceValidationSchema(t);
  }
  return productValidationSchema(t);
};
